import { Link } from "react-router-dom";
import config from "../../app/config";

const RouterLink = ({ to, ...props }) => {

  if (typeof to === "string") {
    return <Link {...props} to={`${to}?brand=${config.brand}`} />;
  } else {
    return (
      <Link
        {...props}
        to={{
          ...to,
          search: to.search ? `${to.search}&brand=${config.brand}` : `?brand=${config.brand}`,
        }}
      />
    );
  }
};

export { RouterLink };
